<template>
  <div class="submission-table">
    <el-table
      :data="submissions"
      style="width: 100%"
    >

      <el-table-column type="expand">
        <template slot-scope="{ row }">
          <p>Submitted on: {{ new Date(row.submission_date).toLocaleString() }}</p>
          <p>Description: “{{ row.description_long }}”</p>
          <p>Film year: {{ row.year }}</p>
        </template>
      </el-table-column>

      <el-table-column
        prop="title"
        label="Film Title"
        min-width="200px"
      />

      <el-table-column
        fixed="right"
        label="(1)"
        width="60px"
        align="center"
      >
        <template slot-scope="{ row, column, $index }">
          <el-radio
            @change="newValue => $emit('change', [row, 'rights_third_party_and_monetization', newValue])"
            label="THIRD_PARTY_AND_MONETIZATION"
            v-model="row.rights_third_party_and_monetization"
          >&nbsp;</el-radio>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="(2)"
        width="60px"
        align="center"
      >
        <template slot-scope="{ row, column, $index }">
          <el-radio
            @change="newValue => $emit('change', [row, 'rights_third_party_and_monetization', newValue])"
            label="THIRD_PARTY_ONLY"
            v-model="row.rights_third_party_and_monetization"
          >&nbsp;</el-radio>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
export default {
  props: {
    submissions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
.submission-table .el-table .cell {
  word-break: break-word;
}

.el-table td.el-table_1_column_2,
.el-table td.el-table_1_column_3 {
  padding: 0;
}
.el-table td.el-table_1_column_2 .cell,
.el-table td.el-table_1_column_3 .cell {
  padding: 0;
}
.el-table td.el-table_1_column_2 .cell .el-radio,
.el-table td.el-table_1_column_3 .cell .el-radio {
  height: 100%;
  width: calc(100% - 40px);
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppyourLicenseRenewalMonetization/MonetizationSubmissionTable.vue